// Local-network backend used while the website is running in development.
const PRIMARY_API_URL = "https://instaport-e6fnbjbhhtbbc7ca.southindia-01.azurewebsites.net";
const BACKUP_API_URL = "https://api.instaportdelivery.in";
const API_STORAGE_KEY = "instaport_active_api_url";

let activeApiUrl = PRIMARY_API_URL;

const getStoredApiUrl = () => {
  try {
    const storedUrl = window.localStorage.getItem(API_STORAGE_KEY);
    return storedUrl === BACKUP_API_URL || storedUrl === PRIMARY_API_URL
      ? storedUrl
      : null;
  } catch (_) {
    return null;
  }
};

const storeActiveApiUrl = (url) => {
  try {
    window.localStorage.setItem(API_STORAGE_KEY, url);
  } catch (_) {}
};

const checkHealth = async (baseUrl) => {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), 3000);

  try {
    const response = await fetch(`${baseUrl}/health`, {
      cache: "no-store",
      signal: controller.signal,
      signal: controller.signal,
    });
    return response.ok;
  } catch (_) {
    return false;
  } finally {
    window.clearTimeout(timeoutId);
  }
};

const initializeApiUrlFallback = async () => {
  const primaryHealthy = await checkHealth(PRIMARY_API_URL);
  if (primaryHealthy) {
    activeApiUrl = PRIMARY_API_URL;
    storeActiveApiUrl(PRIMARY_API_URL);
    return;
  }

  const backupHealthy = await checkHealth(BACKUP_API_URL);
  if (backupHealthy) {
    activeApiUrl = BACKUP_API_URL;
    storeActiveApiUrl(BACKUP_API_URL);
    // eslint-disable-next-line no-console
    console.warn("Primary API unavailable. Using backup API:", BACKUP_API_URL);
    return;
  }

  activeApiUrl = PRIMARY_API_URL;
  storeActiveApiUrl(PRIMARY_API_URL);
};

activeApiUrl = getStoredApiUrl() || PRIMARY_API_URL;
initializeApiUrlFallback();

const API_URL = {
  toString: () => activeApiUrl,
  valueOf: () => activeApiUrl,
  get current() {
    return activeApiUrl;
  },
  primary: PRIMARY_API_URL,
  backup: BACKUP_API_URL,
};

export default API_URL;
